import { ConstraintFacilityExpansionDetailBase } from './base/constraint-facility-expansion-detail-base';

export class ConstraintFacilityExpansionDetail extends ConstraintFacilityExpansionDetailBase { }